import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import moment from "moment";
import { Link, NavLink, useParams } from "react-router-dom";
import Spinner from 'react-bootstrap/Spinner';
import SupportTopMenu from "./SupportTopMenu";

function Inbox(props) {

    const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID, setUserID] = useState(localStorage.getItem("ID"));
    const [tickets, setTickets] = useState([]);
    const [ticketType, setTicketType] = useState(null);
    const [loading, setLoading] = useState(false);
    let params = useParams();


    useEffect(() => {

        setLoading(true);
        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            Status: "Pending",

        };

        var api_config = {
            method: 'post',
            url: config.base_url + 'Support/GetTicketTypesByStatusMemberID',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };


        axios(api_config)
            .then(function (response) {
                if (response.data.status_code == 1) {
                    setTickets(response.data.ListofTickets);
                }

                setLoading(false);
            })
            .catch(function (error) {
                //console.log(error);
            });



    }, []);


    const getFirstChar = (str) => {
        const firstChars = str
            .split(" ")
            .map((word) => word[0])
            .join("");
        return firstChars;
    };


    const renderLogs = () => {
        if (tickets != null && tickets.length > 0) {
            return (
                tickets.map((item, index) => {

                    return (
                        <li key={index} className="list-group-item px-0">
                            <NavLink
                              to={`/support/inbox-counter/${item.ID}`}
                              className="d-flex align-items-center text-decoration-none"
                            >
                              <span className="badge rounded-pill bg-primary me-3">
                                {getFirstChar(item.TicketType)}
                              </span>
                              <span>
                                {item.TicketType}{" "}
                                <span className="text-muted">({item.NoofTickets})</span>
                              </span>
                              <i className="ri-arrow-right-s-line ms-auto"></i>
                            </NavLink>
                        </li>
                    )
                })
            );
        }
        return (
            <li className="list-group-item px-0 text-muted">
                No pending tickets by department.
            </li>
        );
    }


    return (
        <>
            <SupportTopMenu />
            <div className="page-head">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/Dashboard">Dashboard</Link></li>
                                    <li className="breadcrumb-item"> <Link to="/support/raise-ticket">Support</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Inbox</li>
                                </ol>
                            </nav>
                            <div className="page-title">Inbox</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="card">
                    <div className="card-body p-md-4">
                        <div className="form_default">
                            {loading ? (
                              <Spinner animation="border" role="status" />
                            ) : (
                              <ul className="list-group list-group-flush">
                                {renderLogs()}
                              </ul>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Inbox;